module.exports = __webpack_public_path__ + "static/prem-finance-hero-bottom-7765f90d7d2004d2fef386dbe51cfc6a.png";